<template>
  <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card>
                  <v-card-title>
                    <v-layout row wrap align-end >
                    <v-flex xs12>
                      <h1 v-if="step1Data.name">Cadastro de projetos padrões - {{step1Data.name}}</h1>
                      <h1 v-if="!step1Data.name">Cadastro de projetos padrões</h1>
                      <v-spacer></v-spacer>
                    </v-flex>
                    </v-layout>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap >
                      <v-flex xs12 >
                        <v-stepper v-model="e1" alt-labels >
                          <v-stepper-header >
                            <v-stepper-step step="1" :complete="e1 > 1" >Básico</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="2" :complete="e1 > 2">Atividades</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="3" :complete="e1 > 3" style="">Solicitações de evidências</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="4">Submeter</v-stepper-step>
                          </v-stepper-header>
                          <v-stepper-items>
                            <v-stepper-content step="1">
                              <step1 @next="e1 = 2"
                              v-on:result="result"
                              @dados1="step1Atual"
                              @dadoinstruction="instructionAtual"
                              @dadoimage="imagemAtual"></step1>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                              <step2 @next="e1 = 3"
                              @prev="preview"
                              v-on:result="result"
                              :criterios="criterios"
                              :dialog_criterios="dialog_criterios"
                              @dados2="step2Atual"
                              @indicador="contador"
                              @dadotarefa="tarefaAtual"></step2>                              
                            </v-stepper-content>
                            <v-stepper-content step="3" 
                              v-if="atualizar">
                              <step3 @next="e1 = 4"
                              @prev="preview"
                              editable
                              v-on:result="result"
                              :criterios="criterios"
                              :step2Data="step2Data"
                              :dialog_criterios="dialog_criterios"
                              :i="i"
                              @avaliacao="avaliacaoAtual"
                              @dados3="step3Atual"></step3>                              
                            </v-stepper-content>
                            <v-stepper-content step="4">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <h2>Deseja finalizar o cadastro?</h2>
                                  <br>
                                  <v-flex xs6>
                                    <p><strong>Nome: </strong>{{ step1Data.name }}</p>
                                    <br>
                                    <p><strong>Descrição: </strong>{{ step1Data.description }}</p>
                                    <br>
                                    <p><strong>Objetivo: </strong>{{ step1Data.objetivo }}</p>
                                    <br>
                                    <p><strong>Justificativa: </strong>{{ step1Data.justificativa }}</p>
                                    <br>
                                    <p><strong>Recursos: </strong>{{ step1Data.recursos }}</p>
                                    <br>
                                    <p><strong> Quantidade de atividades: </strong>{{ step2Data.length }}</p>
                                    <br>
                                    <p><strong> Quantidade de solicitações: </strong>{{ avaliacao.length }}</p>
                                    <br>
                                  </v-flex>
                                </v-flex>
                                <v-layout align-center justify-end row fill-height>   
                                  <v-btn color="primary"  @click.native="preview" >voltar</v-btn>
                                  <v-btn color="primary" 
                                  :loading="animation" 
                                  @click.native="cadastrar" >
                                    <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
                                    <span v-else>
                                      Finalizar
                                    </span>
                                  </v-btn>
                                </v-layout>
                              </v-layout>
                            </v-stepper-content>                        
                          </v-stepper-items>  
                        </v-stepper>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'
import Step1 from './CadastroSteps/Step1.vue'
import Step2 from './CadastroSteps/Step2.vue'
import Step3 from './CadastroSteps/Step3.vue'
export default {
  components: {
    Step1,
    Step2,
    Step3
  },
  data () {
    return {
      e1: 1,
      step1Data: [],
      step2Data: [],
      step3Data: [],
      modelId: [],
      result: {},
      animation: false,
      image: null,
      hasFile: false,
      dados: [],
      i: 0,
      atualizar: true,
      avaliacao: [],
      payload: [],
      instruction: {},
      hasImage: false,
      loading: false,
      dialog_criterios: false,
      criterios: []
    }
  },
  mounted () {
    this.getcriterio()

    this.$watch('step2Data', function () {
      this.atualizar = false
      // console.log('cadstro stes2')
      this.atualizar = true
    })
  },
  computed: {
    target () {
      return 0
    },
    options () {
      return {
        duration: 0,
        offset: 0
      }
    }
  },
  methods: {
    step1Atual (result) {
      this.step1Data = result
      // console.log('step1', result)
      this.$vuetify.goTo(this.target, this.options)
    },
    step2Atual (result) {
      this.atualizar = false
      this.step2Data = result
      // console.log('step2', result)
      this.atualizar = true
      this.$vuetify.goTo(this.target, this.options)
    },
    step3Atual (result) {
      this.step3Data = result
      // console.log('step3', result)
      this.$vuetify.goTo(this.target, this.options)
    },
    tarefaAtual (result) {
      // console.log('tarefa', result)
      this.step1Data['tarefas_obrigatorias'] = 0
    },
    avaliacaoAtual (result) {
      this.avaliacao = result
      // console.log('avaliacao', result)
      this.$vuetify.goTo(this.target, this.options)
    },
    instructionAtual (result, booleano) {
      this.instruction = result
      this.hasFile = booleano
    },
    imagemAtual (result, booleano) {
      this.image = result
      this.hasImage = booleano
    },
    contador () {
      this.i = this.i + 1
    },
    preview () {
      this.e1 = this.e1 - 1
      this.$vuetify.goTo(this.target, this.options)
    },
    selectID (item) {
      item.habilidades_pks = item.habilidades_pks.map((valor) => {
        return valor.id
      })
      return item
    },
    getcriterio () {
      api.request('GET', 'criterioavaliacao/').then(response => {
        this.criterios = response.data
      }).then(() => {
        this.dialog_criterios = true
      })
    },
    cadastrar () {
      this.animation = true
      this.dados = this.step2Data.map(this.selectID)
      api.request('POST', 'modeloProjetos/', this.step1Data).then(response => {
        this.modelId = response.data.id
        var extension = this.image.name.split('.').pop()

        var name = 'images/padroes/padraoPic_' + response.data.id + '.' + extension
        var upload = this.fbstorage.child(name).put(this.image)

        upload.on('state_changed',
              snapshot => {},
              error => console.log(error),
              url => {
                var payload = { image: name }
                var path = 'modeloProjetos/' + response.data.id + '/'

                api.request('PATCH', path, payload).then(response => {
                  if (this.hasFile) {
                    var extension = this.instruction.name.split('.').pop()

                    var name = 'files/padroes/padraoFile_' + response.data.id + '.' + extension
                    var upload = this.fbstorage.child(name).put(this.instruction)

                    upload.on('state_changed',
                    snapshot => {},
                    error => console.log(error),
                    url => {
                      var payload = { instruction: name }
                      var path = 'modeloProjetos/' + response.data.id + '/'

                      api.request('PATCH', path, payload).then(response => {
                        for (let index = 0; index < this.avaliacao.length; index++) {
                          this.avaliacao[index]['modelo_projetos'] = this.modelId
                          api.request('POST', 'modeloTarefas/', this.avaliacao[index]).then(resp => {
                            console.log(resp.data)
                          })
                        }
                        for (let index = 0; index < this.dados.length; index++) {
                          this.dados[index]['modelo_projetos'] = this.modelId
                          api.request('POST', 'modelo-atividades/', this.dados[index]).then(resp => {
                            console.log(resp.data)
                          })
                        }
                        let route = '/padroes/' + this.modelId
                        this.animation = false
                        this.$router.push(route)
                      }).catch(function (error) {
                        console.log(error)
                        this.animation = false
                      })
                    })
                  } else {
                    for (let index = 0; index < this.avaliacao.length; index++) {
                      this.avaliacao[index]['modelo_projetos'] = this.modelId
                      api.request('POST', 'modeloTarefas/', this.avaliacao[index]).then(resp => {
                        console.log(resp.data)
                      })
                    }
                    for (let index = 0; index < this.dados.length; index++) {
                      this.dados[index]['modelo_projetos'] = this.modelId
                      api.request('POST', 'modelo-atividades/', this.dados[index]).then(resp => {
                        console.log(resp.data)
                      })
                    }
                    let route = '/padroes/' + this.modelId
                    this.animation = false
                    this.$router.push(route)
                  }
                }).catch(function (error) {
                  console.log(error)
                  this.animation = false
                })
              })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Padroes/Cadastro.vue